/** Historický tvar — v UI se nesmí ukazovat. */
const LEGACY_RE = /^PRJ-[0-9A-F]{8}$/;
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isLegacyProjectId(value: unknown): value is string {
  return typeof value === 'string' && LEGACY_RE.test(value);
}

/** Co smí user vidět: UUID záměru, nikdy PRJ-XXXXXXXX. */
export function visibleProjectId(
  identity?: string | null,
  rowId?: string | null,
): string | null {
  const id = typeof identity === 'string' ? identity.trim() : '';
  if (id && !isLegacyProjectId(id)) return id;
  const row = typeof rowId === 'string' ? rowId.trim() : '';
  return row || null;
}

/** Scope `project:<id>:read|write` — UUID i historický tvar. */
export function parseProjectScope(
  scope: unknown,
): { project_id: string; mode: 'read' | 'write' } | null {
  if (typeof scope !== 'string') return null;
  const m = /^project:([^:]+):(read|write)$/.exec(scope);
  if (!m) return null;
  const project_id = m[1]!;
  if (!LEGACY_RE.test(project_id) && !UUID_RE.test(project_id)) return null;
  return { project_id, mode: m[2] as 'read' | 'write' };
}

/** V textu nahradí historické PRJ-XXXXXXXX viditelným UUID. */
export function replaceLegacyProjectId(
  text: string,
  visible?: string | null,
): string {
  const vis = typeof visible === 'string' ? visible.trim() : '';
  return text.replace(/PRJ-[0-9A-F]{8}/gi, vis || 'project');
}
